import React from "react";
import { observer } from "mobx-react";
import { useStore } from "utils/useStore";
import {
    Grid,
    Typography,
    useTheme,
} from "@mui/material";
import { sxClsx } from "utils/styleClsx";
import { AgentLogo } from "../Branding/AgentLogo";
import { AuthStore } from "stores/AuthStore";
import { ConversationInput } from "./ConversationInput";
import AgentStore from "../Stores/AgentStore";
import { KBoUpdateBanner } from "../Update/KBoUpdateBanner";

export const AgentConversationEmpty = observer(
    ({ fullscreen }: { fullscreen?: boolean }) => {
        const agentStore = useStore(AgentStore);

        const theme = useTheme();

        const name =
            agentStore.rootStore.getStore(AuthStore)._user.profile.firstName ||
            "there";

        return (
            <>
                <Grid
                    container
                    item
                    direction="column"
                    flexWrap="nowrap"
                    rowGap={3}
                    flexGrow={1}
                    paddingInline={2}
                    sx={sxClsx(
                        {
                            overflowY: "auto",
                            justifyContent: "center",
                            alignItems: "center",
                        },
                        fullscreen && { maxWidth: "75%" },
                    )}
                >
                    <AgentLogo height={62} width={62} gradient />
                    <Typography
                        sx={{
                            color: theme.palette.gray[700],
                            textAlign: "center",
                            fontSize: "24px",
                            fontWeight: 600,
                            lineHeight: "32px",
                        }}
                    >
                        Hi {name} 👋, what can I help you with?
                    </Typography>
                    {agentStore.showKboUpdateAnnouncement && (
                        <KBoUpdateBanner inline />
                    )}
                    <Typography
                        sx={{
                            color: theme.palette.gray[500],
                            textAlign: "center",
                            fontSize: "16px",
                            fontWeight: 400,
                        }}
                    >
                        Meet KBo - your conversation ally. Just start asking
                        questions! I'm here to surface insights, save time, and
                        help you hear what healthcare really sounds like
                    </Typography>
                </Grid>
                <ConversationInput fullscreen={fullscreen} />
            </>
        );
    },
);
